import React from 'react';
import { Outlet } from 'react-router-dom';
import './../front.css';
import AuthUser from './../Auth/AuthUser';
import LeftMenu from '../layouts/LeftMenu';

const Main = () => {
	const { getloginInfo, user } = AuthUser();
	const IsAuthenticated = getloginInfo==null?false:getloginInfo().IsAuthenticated;
	const isMasterAdmin = getloginInfo == null ? false : getloginInfo().userTypeID;
	if (IsAuthenticated && isMasterAdmin > 1) {
		return <>
			<LeftMenu />
			<Outlet />
		</>;
	}
	return <>
		<div id="main">
			<Outlet />
		</div>

	</>
	
}

export default Main;